The type of event, i.e. PositionProfileClosed. This corresponds to the `Event.typeCode` field in the GraphQL schema.
